<template>
  <div v-if="dialogVisible">
    <slot></slot>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="420px"
      :before-close="cancel"
      top="20%"
    >
      <p>请在新窗口中完成签章操作，若已完成签章，请点击“确定”生成签章附件</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </span>
    </el-dialog>
    <!-- 使用
    <g-signature-popup ref='signaturePopup'></g-signature-popup>
    this.$refs.signaturePopup.showView({
        show,
        belongId: this.$route.query.id,
        fileUrl: data,
        paramcode: 'GB_BID_INVITATION_UPLOAD_ATTACH',
        attachcode: 'GB_BID_INVITATION_UPLOAD_ATTACH'
    })
    -->
  </div>
</template>

<script>
export default {
  name: "GSignature-popup",
  data() {
    return {
      dialogVisible: false,
      belongId: "",
      paramCode: "",
      signCallBack: false,
    };
  },
  props: {
    pdfUrl: {
      type: String,
      default: "",
    },
  },
  methods: {
    showView(ops) {
      //跳转
      const {
        show,
        fileUrl,
        belongId,
        paramcode,
        attachcode,
        signedCheck,
        isAllPages,
        originalName
      } = ops;
      signedCheck?(localStorage.signedCheck=signedCheck) : (localStorage.removeItem('signedCheck')) 
      this.belongId = belongId;
      this.paramCode = paramcode;
      if (show) this.dialogVisible = true;
      const { pathname, origin } = window.location;
      // window.open(  // 原有在线预览pdf组件打开路径--路由preview
      //   `${origin + pathname}#/preview${
      //     show ? "/show" : ""
      //   }?fileUrl=${fileUrl}&belongId=${belongId}&paramcode=${paramcode}&attachcode=${attachcode}&originalName=${originalName}&isAllPages=${isAllPages}`
      // );
      window.open(  // cafe-pdf在线预览pdf打开路径--路由previewpdf
        `${origin + pathname}#/previewpdf${
          show ? "/show" : ""
        }?fileUrl=${fileUrl}&belongId=${belongId}&paramcode=${paramcode}&attachcode=${attachcode}&originalName=${originalName}&isAllPages=${isAllPages}`
      );
    },
    cancel() {
      location.reload();
    },
    confirm() {
      //判断是否已生成签章公告
      if (localStorage.signedCheck) {
        location.reload();
      } else {
        this.$ajax.get(process.env.API_HOST + 'attachmentextend/getAttachment', {
            params: {
              belongId: this.belongId,
              paramCode: this.paramCode,
            },
        }).then((res)=>{
            if (res.data) {
              location.reload();
            }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  /deep/ .el-dialog__body {
    padding: 20px;
    >p{
      line-height: 26px;
    }
    line-height: 20px;
    & > div {
      margin: 60px 0px 60px !important;
    }
    & > .glo-table-wrapper {
      margin: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/signature/popup.vue